export const generalKey = 'product_spu_es001';
export const whiteLocaleList = ['us']; //白名单
export const productPageUrl = 'stream-ultra-home-solar-system';
export const tabsValues = ['Product', 'Specs', 'Support'];
export const productPageTheme = 'white'; //主题色
